<template>
  <div class="breadCrumb">
    <div><h3>Modifier Approvisionnement</h3></div>
    <div>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">Stock</li>
          <li class="breadcrumb-item">Approvisionnements</li>
          <li class="breadcrumb-item active" aria-current="page">Modification</li>
        </ol>
      </nav>
    </div>
  </div>

  <div class="card p-3">
    <!-- Ligne 1 -->
    <div class="row p-2">
      <div class="col-md-6 mb-3">
        <label class="form-label">Médicament</label>
        <select class="form-select" v-model="form.medicament" :class="{ 'is-invalid': error.medicament }">
          <option disabled value="">-- Sélectionnez --</option>
          <option v-for="med in medicaments" :key="med.id" :value="med.id">{{ med.nom }}</option>
        </select>
        <div class="invalid-feedback">{{ error.medicament }}</div>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Conditionnement</label>
        <select class="form-select" v-model="form.conditionnement" :class="{ 'is-invalid': error.conditionnement }">
          <option disabled value="">-- Sélectionnez --</option>
          <option v-for="cond in conditionnements" :key="cond.id" :value="cond.id">{{ cond.nom }}</option>
        </select>
        <div class="invalid-feedback">{{ error.conditionnement }}</div>
      </div>
    </div>

    <!-- Ligne 2 -->
    <div class="row p-2">
      <div class="col-md-4">
        <label class="form-label">Quantité</label>
        <input type="number" class="form-control" v-model="form.quantite" :class="{ 'is-invalid': error.quantite }">
        <div class="invalid-feedback">{{ error.quantite }}</div>
      </div>
      <div class="col-md-4">
        <label class="form-label">Prix d'achat</label>
        <input type="number" class="form-control" v-model="form.prixAchat" :class="{ 'is-invalid': error.prixAchat }">
        <div class="invalid-feedback">{{ error.prixAchat }}</div>
      </div>
      <div class="col-md-4">
        <label class="form-label">Prix de vente</label>
        <input type="number" class="form-control" v-model="form.prixVente" :class="{ 'is-invalid': error.prixVente }">
        <div class="invalid-feedback">{{ error.prixVente }}</div>
      </div>
    </div>

    <!-- Ligne 3 -->
    <div class="row p-2">
      <div class="col-md-6">
        <label class="form-label">Date d'approvisionnement</label>
        <input type="date" class="form-control" v-model="form.dateApprovisionnement" :class="{ 'is-invalid': error.dateApprovisionnement }">
        <div class="invalid-feedback">{{ error.dateApprovisionnement }}</div>
      </div>
      <div class="col-md-6">
        <label class="form-label">Date de péremption</label>
        <input type="date" class="form-control" v-model="form.datePeremption" :class="{ 'is-invalid': error.datePeremption }">
        <div class="invalid-feedback">{{ error.datePeremption }}</div>
      </div>
    </div>

    <!-- Ligne 4 -->
    <div class="row p-2">
      <div class="col-md-4">
        <label class="form-label">Nombre par unité</label>
        <input type="number" class="form-control" v-model="form.nombreParUnite">
      </div>
      <div class="col-md-4">
        <label class="form-label">Total Achat</label>
        <input type="number" class="form-control" :value="form.quantite * form.prixAchat" readonly>
      </div>
      <div class="col-md-4">
        <label class="form-label">Total Vente</label>
        <input type="number" class="form-control" :value="form.quantite * form.prixVente" readonly>
      </div>
    </div>

    <!-- Ligne 5 -->
    <div class="form-check form-switch m-2">
      <input class="form-check-input" type="checkbox" id="enabledSwitch" v-model="form.isEnabled">
      <label class="form-check-label" for="enabledSwitch">Activer l'approvisionnement</label>
    </div>

    <!-- Boutons -->
    <div class="d-flex justify-content-between p-2">
      <button class="btn btn-danger" @click="cancel">Annuler</button>
      <button class="btn btn-success" :disabled="loading" @click="updateItem">
        <span v-if="loading">chargement...</span>
        <span v-else>Mettre à jour</span>
      </button>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {
        loading: false,
      
      form: {
        id: null,
        medicament: '',
        conditionnement: '',
        quantite: 0,
        prixAchat: 0,
        prixVente: 0,
        nombreParUnite: null,
        dateApprovisionnement: '',
        datePeremption: '',
        isEnabled: true,
      },
      medicaments: [],
      conditionnements: [],
      error: {}
    };
  },
  methods: {
    async loadData() {
      try {
        const id = this.$route.params.id;
        const response = await api.getItem('approvisionnements', id);
        this.form = {
          ...response.data,
          dateApprovisionnement: response.data.dateApprovisionnement?.split('T')[0],
          datePeremption: response.data.datePeremption?.split('T')[0],
          medicament:response.data.medicament?.id,
          conditionnement:response.data.conditionnement?.id
        };
       
        console.log('medicamane complet est:',response.data);
      } catch (err) {
        console.error('Erreur lors du chargement', err);
      }
    },
    async initForm() {
    try {
      await this.loadDependencies();      
      await this.loadData();              
    } catch (e) {
      console.error("Erreur lors de l'initialisation du formulaire", e);
    }
  },
    async loadDependencies() {
      try {
        const [meds, conds] = await Promise.all([
          api.getItems('medicaments'),
          api.getItems('conditionnements')
        ]);
        this.medicaments = meds.data?.data || [];
        this.conditionnements = conds.data?.data || [];
      
      } catch (err) {

        console.error('Erreur lors du chargement des dépendances', err);
      }
    },
    validateForm() {
      this.error = {};
      if (!this.form.medicament) this.error.medicament = 'Champ requis';
      if (!this.form.conditionnement) this.error.conditionnement = 'Champ requis';
      if (!this.form.quantite || this.form.quantite <= 0) this.error.quantite = 'Quantité invalide';
      if (!this.form.prixAchat || this.form.prixAchat <= 0) this.error.prixAchat = 'Prix invalide';
      if (!this.form.prixVente || this.form.prixVente <= 0) this.error.prixVente = 'Prix invalide';
      if (!this.form.dateApprovisionnement) this.error.dateApprovisionnement = 'Champ requis';
      if (!this.form.datePeremption) this.error.datePeremption = 'Champ requis';

      return Object.keys(this.error).length === 0;
    },
    async updateItem() {
      if (!this.validateForm()) return;

      try {
        this.loading = true;
        await api.updateItem('approvisionnements', this.form.id, {
          ...this.form,
          dateApprovisionnement: new Date(this.form.dateApprovisionnement).toISOString(),
          datePeremption: new Date(this.form.datePeremption).toISOString(),
        });
      
        this.$router.push({ name: 'liste_approvisionnement' });
      } catch (err) {
        console.error('Erreur lors de la mise à jour', err);
      } finally {
        this.loading = true;
      }
    },
    cancel() {
      this.$router.push({ name: 'liste_approvisionnement' });
    }
  },
  created() {
    //this.loadDependencies();
    //this.loadData();
    this.initForm();
  }
};
</script>

<style scoped>
.breadCrumb {
  display: flex;
  justify-content: space-between;
  padding: 8px;
}
</style>
